import type { useContentLabelsDetailsPanelContentLabelsQuery$data } from '../hooks/__generated__/useContentLabelsDetailsPanelContentLabelsQuery.graphql.ts';

export const normalizeContentLabelsData = (
	data?: useContentLabelsDetailsPanelContentLabelsQuery$data,
): {
	labels: (
		| {
				readonly id: string | null | undefined;
				readonly label: string | null | undefined;
				readonly name: string | null | undefined;
				readonly prefix: string | null | undefined;
		  }
		| null
		| undefined
	)[];
	hasEditPermissions: boolean;
} => {
	const nodes = data?.singleContent?.labels?.nodes;
	const firstNode = data?.content?.nodes?.[0];
	const operations = firstNode?.operations ?? [];
	const type = firstNode?.type;

	const hasEditPermissions = Boolean(
		operations?.find((item) => item?.operation === 'update' && item?.targetType === type),
	);

	const labels = nodes?.filter((node) => node?.name !== 'favourite' || node?.prefix !== 'my') || [];

	return {
		labels,
		hasEditPermissions,
	};
};
